/**
 * Barres mobiles (Batch #14.322) — catalogues des raccourcis affichables en bas d'écran sur téléphone.
 *  - ADMIN_MOBILE_TABS : barre admin (Accueil et Menu sont fixes ; le cabinet choisit jusqu'à 3 raccourcis dans Paramètres › Barre mobile).
 *  - PORTAL_MOBILE_TABS : barre du portail client (Accueil fixe ; jusqu'à 4 tuiles choisies par le cabinet, filtrées par les accès du client).
 */
import {
  Bell, BookOpen, BookOpenCheck, Briefcase, BriefcaseBusiness, Building2, Calendar, CalendarDays, Cog, FileSignature, FileText,
  HandCoins, Home, Inbox, Landmark, ListChecks, MessageCircle, Receipt, Search, Upload, User,
} from "lucide-react";

export const ADMIN_MOBILE_MAX = 3;
export const PORTAL_MOBILE_MAX = 4;

export const ADMIN_MOBILE_TABS = [
  { id: "cabinet", label: "Cabinet", icon: Briefcase, path: "/admin/cabinet", match: (p) => p.startsWith("/admin/cabinet") || p.startsWith("/admin/comptabilite") || p.startsWith("/admin/masters") },
  { id: "fiscal", label: "Fiscal", icon: Landmark, path: "/admin/fiscal", match: (p) => p.startsWith("/admin/fiscal") },
  { id: "paie", label: "Paie", icon: HandCoins, path: "/admin/paie", match: (p) => p.startsWith("/admin/paie") },
  { id: "tenue-livres", label: "Tenue livres", icon: BookOpenCheck, path: "/admin/tenue-livres", match: (p) => p.startsWith("/admin/tenue-livres") },
  { id: "immeubles", label: "Immeubles", icon: Building2, path: "/admin/immeubles", match: (p) => p.startsWith("/admin/immeuble") },
  { id: "pms", label: "Files PMS", icon: Inbox, path: "/admin/pms-queue", match: (p) => p.startsWith("/admin/pms-queue") },
  { id: "comms", label: "Comms", icon: MessageCircle, path: "/admin/documents", match: (p) => p.startsWith("/admin/documents") || p.startsWith("/admin/communications") },
  { id: "tasks", label: "Tâches", icon: ListChecks, path: "/admin/tasks", match: (p) => p.startsWith("/admin/tasks") },
  { id: "appointments", label: "RDV", icon: CalendarDays, path: "/admin/appointments", match: (p) => p.startsWith("/admin/appointments") },
  { id: "search", label: "Rechercher", icon: Search, action: "search" },
  { id: "settings", label: "Paramètres", icon: Cog, path: "/admin/settings", match: (p) => p.startsWith("/admin/settings") },
];
export const ADMIN_MOBILE_DEFAULT = ["cabinet", "tasks", "search"];

export const PORTAL_MOBILE_TABS = [
  { id: "info", label: "Info", icon: User },
  { id: "documents", label: "Documents", icon: FileText, badge: "documents" },
  { id: "envoyer", label: "Envoyer", icon: Upload },
  { id: "chat", label: "Chat", icon: MessageCircle, badge: "chat" },
  { id: "rdv", label: "RDV", icon: Calendar, badge: "appointments" },
  { id: "mandats", label: "À signer", icon: FileSignature, badge: "mandats" },
  { id: "factures", label: "Factures", icon: Receipt },
  { id: "t777", label: "Bureau", icon: Briefcase },
  { id: "travail_autonome", label: "Entreprise", icon: BriefcaseBusiness },
  { id: "paie", label: "Paie", icon: HandCoins },
  { id: "immeuble", label: "Immeuble", icon: Home },
  { id: "notifications", label: "Alertes", icon: Bell },
  { id: "mode_emploi", label: "Aide", icon: BookOpen },
];
export const PORTAL_MOBILE_DEFAULT = ["documents", "envoyer", "chat", "rdv"];

/** Résout une liste d'ids (réglage) en entrées du catalogue, dans l'ordre choisi, bornée à `max`. */
export const resolveTabs = (catalog, ids, fallback, max) => {
  const list = Array.isArray(ids) && ids.length ? ids : fallback;
  return list.map((id) => catalog.find((t) => t.id === id)).filter(Boolean).slice(0, max);
};
